import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

function fetchCustomerCart(_x) {
  return _fetchCustomerCart.apply(this, arguments);
}

function _fetchCustomerCart() {
  _fetchCustomerCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context) {
    var locale, xhrUri, _ref, data;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/ajax_customer_details.json");
            _context.next = 4;
            return context.$axios.get(xhrUri, {
              withCredentials: true
            });

          case 4:
            _ref = _context.sent;
            data = _ref.data;
            return _context.abrupt("return", data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchCustomerCart.apply(this, arguments);
}

function addCustomerCartCustomizable(_x2, _x3) {
  return _addCustomerCartCustomizable.apply(this, arguments);
}

function _addCustomerCartCustomizable() {
  _addCustomerCartCustomizable = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, payload) {
    var locale, xhrUri, _ref2, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/custom/panier/").concat(payload);
            _context2.next = 4;
            return context.$axios.get(xhrUri, {
              'axios-retry': {
                retries: 0
              }
            });

          case 4:
            _ref2 = _context2.sent;
            data = _ref2.data;
            return _context2.abrupt("return", data);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _addCustomerCartCustomizable.apply(this, arguments);
}

function addCustomerCart(_x4, _x5) {
  return _addCustomerCart.apply(this, arguments);
}

function _addCustomerCart() {
  _addCustomerCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(context, payload) {
    var locale, xhrUri, _ref3, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/").concat(payload.referenceEncoded, "/").concat(payload.quantity);
            _context3.next = 4;
            return context.$axios.get(xhrUri, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              },
              'axios-retry': {
                retries: 0
              }
            });

          case 4:
            _ref3 = _context3.sent;
            data = _ref3.data;
            return _context3.abrupt("return", data);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _addCustomerCart.apply(this, arguments);
}

function updateCustomerCart(_x6, _x7) {
  return _updateCustomerCart.apply(this, arguments);
}

function _updateCustomerCart() {
  _updateCustomerCart = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(context, payload) {
    var locale, xhrUri, _ref4, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            locale = context.state.i18n.currentLocale;
            xhrUri = "".concat(context.state.sharedEnv.payload.web).concat(locale.market, "/").concat(locale.language, "/panier/changer/").concat(payload.reference, "/").concat(payload.quantity);
            _context4.next = 4;
            return context.$axios.get(xhrUri, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest'
              }
            });

          case 4:
            _ref4 = _context4.sent;
            data = _ref4.data;
            return _context4.abrupt("return", data);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _updateCustomerCart.apply(this, arguments);
}

export { fetchCustomerCart, addCustomerCart, addCustomerCartCustomizable, updateCustomerCart };